import React, {Fragment} from 'react';
import './FragranceCard.css';
import Badge from '../Badge/Badge';
import notes from '../../data/notes';

const findFamily = family => {
  if(!family) return null
  const familyDetails = notes.find( note => ( note.name.trim() === family.toLowerCase().trim() ))
  return familyDetails
}

export default (props) => (
  <Fragment>
    <div className="fragranceCard" id={props.skinny || !props.name ? null : props.name.replace(' ', '-').toLowerCase()}>
      { props.isWinner ?
        <div className="winnerBadge">
          <h3>Top Recommendation</h3> 
        </div>
      : null}
      <div className="bottleImage">
        <img src={props.prodImgUrl} /> 
        
      </div>    
      <div className="wishlistWrapper">
        { props.canAdd && !props.inBasket ?
          <button
            className="button button--dark basketButton"
            onClick={props.addToBasket}
          >
            <img src="/img/bag-white.svg" />
            <span>Add to bag</span>
          </button>
        : props.inBasket ?
          <button
            className="button button--inverted"
            onClick={props.removeFromBasket}
          >
            Remove 
          </button>
        :
          <button
            disabled
            className="button button--dark"
          >
            Add to basket
          </button>
        }
      </div>
      <div className="cardHeader">
        <h1>{props.name}</h1> 
        <h3>{props.fragranceType}</h3>
      </div>
      <div className="cardContent">
        { props.blurb ?
          <p>{props.description.substr(0, props.skinny ? 70 : 170)}&hellip;</p>
        : null }
        <div className="families">
          <Badge
            text={props.primaryFamily}
            background={ findFamily(props.primaryFamily) ? findFamily(props.primaryFamily).background : null }
            color={ findFamily(props.primaryFamily) ? findFamily(props.primaryFamily).fontColor : null }
          />
        </div>
      </div>
      <footer className="fragranceNotes">
        { props.headNote ?
          <div className="note">
            <h4>Head</h4> 
            <img src={`/img/notes/${props.headNote.trim().replace(/\s+/g, '-').toLowerCase()}.png`} />
            <p>{props.headNote}</p>
          </div> 
        : null }
        {props.heartNote ?
          <div className="note">
            <h4>Heart</h4> 
            <img src={`/img/notes/${props.heartNote.trim().replace(/\s+/g, '-').toLowerCase()}.png`} />
            <p>{props.heartNote}</p>
          </div>
        : null }
        { props.baseNote ?
          <div className="note">
            <h4>Base</h4> 
            <img src={`/img/notes/${props.baseNote.trim().replace(/\s+/g, '-').toLowerCase()}.png`} />
            <p>{props.baseNote}</p>
          </div>
        : null }
      </footer>
    </div>
  </Fragment>
)


// WEBPACK FOOTER //
// ./src/components/FragranceCard/FragranceCard.js